"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var styles_1 = __importDefault(require("../styles"));
var ColorlibStepIcon = function (props) {
    var _a;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var active = props.active, completed = props.completed, icon = props.icon;
    var stepNumber = String(icon);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.root, (_a = {},
            _a[classes.active] = active,
            _a[classes.completed] = completed,
            _a)) }, stepNumber));
};
var getSteps = function () { return ['', '', '']; };
var RegistrationStepper = function (_a) {
    var activeStep = _a.activeStep, onPress = _a.onPress;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var steps = getSteps();
    var stepAriaLabels = [
        t('registration.stepper.screenReaderStep1'),
        t('registration.stepper.screenReaderStep2'),
        t('registration.stepper.screenReaderStep3')
    ];
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Stepper, { role: "list", "aria-label": t('registration.stepper.screenReader', 'Follow these steps to register'), alternativeLabel: true, activeStep: activeStep, className: classes.stepper }, steps.map(function (label, index) {
            var onButtonPress = function () {
                onPress(index);
            };
            var isActiveStep = index === activeStep;
            return (react_1.default.createElement(core_1.Step, { key: "step-".concat(label), role: "listitem", "aria-label": stepAriaLabels[index], "aria-current": isActiveStep ? 'step' : undefined, onClick: onButtonPress },
                react_1.default.createElement(core_1.StepLabel, { "aria-hidden": 'true', StepIconComponent: ColorlibStepIcon })));
        }))));
};
exports.default = RegistrationStepper;
//# sourceMappingURL=RegistrationStepper.js.map